import { createContext, useContext } from 'react';

const ModalNewResourceContext = /* @__PURE__ */ createContext({});
const useModalNewResourceContext = () => useContext(ModalNewResourceContext);
const ModalNewResourceContextProvider = ModalNewResourceContext.Provider;

export { ModalNewResourceContextProvider, useModalNewResourceContext };
//# sourceMappingURL=ModalNewResourceContext.js.map
